const navbar = () => {

  // Navbar Toggler
  const navbar = document.querySelector('.navbar');
  if (!navbar) return;
  const navbarToggler = navbar.querySelector('.navbar__toggler');
  navbarToggler.addEventListener('click', () => {
    navbar.classList.toggle('open');
  })

  // Anchor links smooth scroll
  const smoothScrollTo = (to, duration) => {
    const start = window.scrollY;
    const distance = to - start;
    let startTime = null;
    const ease = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, start + distance * ease(progress));
      if (elapsed < duration) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    const href = link.getAttribute('href');
    if (href.length <= 1) return;
    link.addEventListener('click', (e) => {
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      navbar.classList.remove('open');
      setTimeout(() => {
        const navbarHeight = document.querySelector('.navbar').offsetHeight;
        const targetPosition = target.getBoundingClientRect().top + window.scrollY;
        smoothScrollTo(targetPosition - navbarHeight, 900);
      }, 300);
    });
  });

  // Scroll Effect
  // const scrollEffect = () => {
  //   if (window.scrollY > 60) {
  //     document.body.classList.add('scrolled');
  //   } else {
  //     document.body.classList.remove('scrolled');
  //   }
  // }

  // scrollEffect();
  // window.addEventListener('scroll', () => {
  //   scrollEffect();
  // });




};

export default navbar;
